app.service('lazyLoad', function () {
	var lazyLoad;

	function check() {
		lazyLoad.handleScroll();
	}

	function update() {
		lazyLoad.update();
	}

	function setEvents() {
		var $document = $(document);
		$document.ajaxComplete(update);
		$document.on('lazyLoad:check', check);
		$document.on('opening, opened', '.remodal', update);
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			lazyLoad = new LazyLoad({
				elements_selector: "img.lazy"
			});
			setEvents();
		} else {
			update();
		}
	}

	return {
		init,
		update
	};
});
